var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M31.5781 12.6719C31.5781 12.0312 31.2969 11.3594 30.8594 10.9375L20.7188 0.796875C20.2188 0.296875 19.625 0.046875 19.0625 0.046875C17.6719 0.046875 16.75 1 16.75 2.26562C16.75 2.98438 17.0469 3.53125 17.4844 3.95312L21.0469 7.51562L24.2656 10.5L20.9062 10.3125H3.4375C1.96875 10.3125 0.984375 11.2656 0.984375 12.6719C0.984375 14.0781 1.96875 15.0156 3.4375 15.0156H20.9062L24.2812 14.8438L21.0469 17.8125L17.4844 21.3594C17.0625 21.7969 16.75 22.3438 16.75 23.0469C16.75 24.3125 17.6719 25.2812 19.0625 25.2812C19.625 25.2812 20.2031 25.0312 20.7031 24.5469L30.8594 14.3906C31.2969 13.9688 31.5781 13.2969 31.5781 12.6719Z"}));
}

Arrow.defaultProps = {"width":"32","height":"26","viewBox":"0 0 32 26","aria-label":"Submit button"};

module.exports = Arrow;

Arrow.default = Arrow;
